import React from 'react';
import { TarotCard } from './TarotCard';
import { TarotCardData } from '../types/tarot';

interface SelectedCardsProps {
  selectedCards: TarotCardData[];
  maxCards: number;
  onCardClick: (card: TarotCardData) => void;
  onEmptySlotTap?: () => void;
}

export const SelectedCards: React.FC<SelectedCardsProps> = ({
  selectedCards,
  maxCards,
  onCardClick,
  onEmptySlotTap,
}) => {
  return (
    <div className="flex justify-center space-x-3 px-0">
      {[...Array(maxCards)].map((_, index) => {
        const card = selectedCards[index];
        
        return (
          <div key={index} className="w-40 sm:w-44 aspect-[2/3]">
            {card ? (
              <TarotCard
                card={card}
                isFlipped={true}
                onClick={() => onCardClick(card)}
                className="w-full h-full"
                borderRadius="lg"
              />
            ) : (
              <button
                type="button"
                className="w-full h-full border-2 border-dashed border-purple-400/50 rounded-lg flex items-center justify-center bg-black/20 backdrop-blur-sm transition-colors hover:border-purple-300/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400/60"
                onPointerDown={onEmptySlotTap}
                onClick={onEmptySlotTap}
              >
                <div className="w-8 h-8 rounded-full border border-purple-300/50">
                </div>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
